import { createContext, use } from "react"

export const ReducedMotionContext = createContext(false)

export const useReducedMotion = () => use(ReducedMotionContext)
